var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('account-alerts')],1),_c('div',{staticClass:"mt-3"},[_c('account-todo-list')],1),_c('div',{staticClass:"mt-3"},[_c('account-activity')],1),_c('div',{staticClass:"mt-3"},[_c('account-profile')],1),_c('div',{staticClass:"mt-3"},[_c('account-settings')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }